<template>
  <div class="my-3">
    <label>System Message</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-ls-12 border p-3">
        <p>{{ message ? message : "" }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointProgramsSystemMessage",

  props: {
    message: String,
  },

  data() {
    return {};
  },

  method: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scrollToTop();
  },
};
</script>

<style lang="scss" scoped>
</style>
